import { createTheme } from '@mui/material/styles';
import {
  common, green, blue, blueGrey, grey
} from '@mui/material/colors';
import shadows from './shadows';
import typography from './typography';

const createAppTheme = (mode = 'light') => {
  const isDark = mode === 'dark';

  return createTheme({
    palette: {
      mode,
      background: isDark
        ? {
          dark: '#0B0E11',
          default: '#121417',
          paper: '#1A1D21'
        }
        : {
          dark: '#F4F6F8',
          default: common.white,
          paper: common.white
        },
      primary: {
        main: green[500],
        contrastText: '#fff'
      },
      secondary: {
        main: blue[500]
      },
      text: isDark
        ? {
          primary: grey[100],
          secondary: grey[500]
        }
        : {
          primary: blueGrey[900],
          secondary: blueGrey[600]
        }
    },
    shadows,
    typography,
    shape: {
      borderRadius: 10
    },
    components: {
      MuiAppBar: {
        defaultProps: {
          enableColorOnDark: true
        }
      },
      MuiButton: {
        defaultProps: {
          disableElevation: true
        },
        styleOverrides: {
          containedPrimary: {
            color: 'white'
          }
        }
      },
      MuiAccordionSummary: {
        styleOverrides: {
          root: {
            background: isDark ? 'rgba(76, 175, 80, 0.2)' : '#4caf508a'
          }
        }
      }
    }
  });
};

export default createAppTheme;
